import React from 'react'

import clsx from 'clsx'

import Avatar from 'components/Avatar'
import Icon from 'components/Icon'
import { useEventContext } from 'context/EventContext'

import avatarImg from './assets/avatar.png'

import classes from './ClickToCall.module.scss'

const CONSULTATION_PHONE = '+18882166745'

/** @type {import("./types").default} */
const ClickToCall = ({ className }) => {
  const { addEvent } = useEventContext({
    engagementComponent: 'click-to-call',
    engagementDestination: 'go-to_call',
    engagementDetails: 'button_click-to-call',
    name: 'engagement_category',
  })
  return (
    <div className={clsx('ClickToCall', className, classes.root)}>
      <div className={classes.header}>
        <Avatar className={classes.avatar} src={avatarImg.src}>
          <Icon icon={['fas', 'user']} />
        </Avatar>
        <div className={classes.content}>
          <span className={classes.title}>Get free expert advice</span>
          <a href={`tel:${CONSULTATION_PHONE}`} className={classes.phone} {...addEvent()}>
            +1 (888) 216-6745
          </a>
        </div>
      </div>
      <div className={classes.more}>Call now for a one-to-one consultation in under 15 mins.</div>
    </div>
  )
}

export default ClickToCall
